// @ts-nocheck
// Console for generic_simulator - Reference from MDA (addedConsolemda) and command_center

import React, { useEffect, useState, useRef, useMemo } from "react";
import {
  PinSvg,
  DownloadIcon,
  ThreeDotIcon,
  CheckboxCheckedSvg,
  CheckboxUncheckedSvg,
  DraggableHandle,
  CloseIcon,
  TcTmCombinedIcon,
  TcTmCombinedGreenIcon,
  TcIconGreen,
  TmIconGreen,
} from "../../../command_center/components/center/modals/Svgs";
import { BeaconSvg, HealthMetricSvg, InvalidTmSvg } from "../../../command_center/components/center/modals/console/ConsoleSvg";
import { get_formated_time } from "../../../command_center/components/center/modals/console/Utils";
import useModals from "../../hooks/useModals";
import useConsole from "../../hooks/useConsole";
import useUrlParams from "../../hooks/useUrlParams";
import useDashboard from "../../hooks/useDashboard";
import { Modals } from "../../context";
import CustomToolTip from "../../../CommonComponents/CustomToolTip";
import CustomFilter from "../../../CommonComponents/custom_filter/CustomFilter";
import { getBands, getFilterOption } from "../../../command_center/components/center/modals/console/Utils";
import { AllFilterType, FilterListType } from "../../../CommonComponents/custom_filter/types";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import { arrayMove } from "react-sortable-hoc";
import Modal from "../../../command_center/components/center/modals/Modal";
import ConsoleOutputSection from "./ConsoleOutputSection";
import RawBytesOutputSection from "./RawBytesOutputSection";
import "../../../command_center/components/center/modals/console/Console.scss";

const DragHandle = SortableHandle(() => (
  <div style={{ cursor: "grab" }}>
    <DraggableHandle />
  </div>
));

const SortableRow = React.memo(
  SortableElement(({ rowData, row_index, setConsoleTableColumns, setIsTableWidth, isTableWidth }) => {
    const toggleSelected = () => {
      setConsoleTableColumns(prev => {
        const next = [...prev];

        const current = next[row_index];
        const nextSelected = !current.isSelected;

        next[row_index] = {
          ...current,
          isSelected: nextSelected
        };

        setIsTableWidth(prevWidth =>
          nextSelected
            ? prevWidth + Number(current.width) // deselecting
            : prevWidth - Number(current.width) // selecting
        );

        return next;
      });
    };

    return (
      <div style={{ userSelect: "none" }} className="three_dot_console_body__item">
        <DragHandle />
        <button className=""
          onClick={toggleSelected}
        >
          {rowData.isSelected ? <CheckboxCheckedSvg /> : <CheckboxUncheckedSvg />}
        </button>
        <div style={{ userSelect: "none" }}
          onClick={toggleSelected}
        >
          {rowData.label}
        </div>
      </div>
    );
  })
);

const ThreeDotMenuPopUp = SortableContainer(({ threeDotMenuPopUpRef, isSelectAllFiltersActive, setIsTableWidth, consoleTableColumns, setConsoleTableColumns, isTableWidth }) => (
  <div
    className="console__container__three_dot_menu_pop_up_container"
    ref={threeDotMenuPopUpRef}
    onClick={(e) => e.stopPropagation()}
    onDragStart={(e) => e.stopPropagation()}
    onMouseDown={(e) => e.stopPropagation()}
    onSelectStart={(e) => e.stopPropagation()}
  >
    <div className="three_dot_console_header">
      <div>Fields</div>
      <button
        className={isSelectAllFiltersActive ? "active" : "inactive"}
        onClick={() => {
          setConsoleTableColumns((prev) => prev.map((item) => ({ ...item, isSelected: true })));
          setIsTableWidth(1400);
        }}
      >
        Select All
      </button>
    </div>
    <div className="three_dot_console_body">
      {consoleTableColumns?.map((rowData, index) => (
        <>{index !== 0 && index !== 1 && <SortableRow key={`row-${index}`} index={index} rowData={rowData} row_index={index} setConsoleTableColumns={setConsoleTableColumns} setIsTableWidth={setIsTableWidth} isTableWidth={isTableWidth} />}</>
      ))}
    </div>
  </div>
));

const GenericSimulatorConsole = () => {
  const { loading, error, commandDetails, getCommandDetails, exportMessages } = useConsole();
  const { selected_element, scenario, simulation_time } = useDashboard();
  const { trueTwinId } = selected_element || {};
  const [resizing, setResizing] = useState(false);
  const { dashboard } = useUrlParams();
  const { open_modal, close_modal, pinned_modal, get_modal_details, close_all_unpinned_modals } = useModals();
  const [show_rawbytes, set_show_rawbytes] = useState(false);
  const [isFrozen, setIsFrozen] = useState(false);
  const [isTableWidth, setIsTableWidth] = useState(1400);
  const [timeRange, setTimeRange] = useState<{ start: number; end: number } | null>(null);

  const modal: Modals = get_modal_details("generic_simulator_console");

  const handleOpenConsole = (event: any) => {
    event.stopPropagation();
    open_modal("generic_simulator_console");
  };

  const handlePinFunctionality = (event: any) => {
    event.stopPropagation();
    pinned_modal("generic_simulator_console");
  };

  const handleCloseConsole = (event: any) => {
    event.stopPropagation();
    close_modal("generic_simulator_console");
    set_show_rawbytes(false);
    setIsFrozen(false);
  };

  const [isTableFiltersVisible, setIsTableFiltersVisible] = useState(false);
  const [isResetActive, setIsResetActive] = useState(false);
  const [isSelectAllFiltersActive, setIsSelectAllFiltersActive] = useState(false);

  const [consoleTableColumns, setConsoleTableColumns] = useState([
    {
      label: "TcTmType",
      value: (entry: any) => entry?.CommandDetails?.tctmType,
      isSelected: true,
      width: 36,
      isSvg: true,
      svg: <TcTmCombinedIcon />,
      isFilterAvailable: false,
      renderIcon: (entry: any) => {
        const type = entry?.CommandDetails?.tctmType;
        switch (type) {
          case "Health Metric":
            return <HealthMetricSvg color={'#7AB3FF'} />;
          case "Beacon":
            return <BeaconSvg color={'#7AB3FF'} />;
          case "Invalid TM":
            return <InvalidTmSvg color={'#C91818'} />;
          case "TM":
          case "tm":
            return <TmIconGreen />;
          case "TC":
          case "tc":
            return <TcIconGreen />;
          case "TCTM":
            return <TcTmCombinedGreenIcon />;
          default:
            return null;
        }
      },
      dashboard: "summary",
    },
    { label: "Time", value: (entry: any) => get_formated_time(entry?.CommandDetails?.timestamp), isSelected: true, width: 160, isFilterAvailable: true, dashboard: "summary" },
    { label: "TC/TM ID", value: (entry: any) => entry?.CommandDetails?.tctmId, isSelected: true, width: 100, isFilterAvailable: true, dashboard: "summary" },
    { label: "Source", value: (entry: any) => entry?.CommandDetails?.saId, isSelected: true, width: 80, isFilterAvailable: true, dashboard: "summary" },
    { label: "Destination", value: (entry: any) => entry?.CommandDetails?.daId, isSelected: true, width: 100, isFilterAvailable: true, dashboard: "summary" },
    { label: "Bytes Length", value: (entry: any) => entry?.CommandDetails?.frameLength, isSelected: true, width: 100, isFilterAvailable: false, dashboard: "summary" },
    { label: "Info", value: (entry: any) => entry?.Info ?? "--", isSelected: true, width: 140, isFilterAvailable: false, dashboard: "operate" },
  ]);

  const threeDotMenuPopUpRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (threeDotMenuPopUpRef.current && !threeDotMenuPopUpRef.current.contains(event.target)) {
        setIsTableFiltersVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [modal]);

  const handleSortEnd = ({ oldIndex, newIndex }: any) => {
    if (oldIndex !== newIndex) {
      setConsoleTableColumns((prev) => arrayMove([...prev], oldIndex, newIndex));
    }
  };

  const [audioWaveformFilters, setAudioWaveformFilters] = useState({ S: false, UHF: false });
  const [tcTmTypeFilters, setTcTmTypeFilters] = useState({ invalid: false, healthMetric: false, beacon: false });
  const [allFilters, setAllFilters] = useState<AllFilterType>({ bandsFilter: [], tctmFilter: [], advanceFilters: [], timeFilter: { startTime: null, endTime: null } });

  const { consoleFilterOptions } = useConsole();
  const filterOption: FilterListType | null = useMemo(() => getFilterOption(consoleFilterOptions), [consoleFilterOptions]);
  const bandOptions: { label: string; value: string }[] = useMemo(() => getBands(consoleFilterOptions), [consoleFilterOptions]);

  useEffect(() => {
    if (simulation_time?.start_time != null && simulation_time?.end_time != null) {
      setTimeRange({ start: simulation_time.start_time, end: simulation_time.end_time });
    } else if (scenario?.scenarioStartTime != null && scenario?.scenarioDuration != null) {
      const start = scenario.scenarioStartTime;
      const end = start + scenario.scenarioDuration * 60;
      setTimeRange({ start, end });
    } else {
      setTimeRange(null);
    }
  }, [simulation_time, scenario]);

  const reset_filters = () => {
    setAudioWaveformFilters({ S: false, UHF: false });
    setTcTmTypeFilters({ invalid: false, healthMetric: false, beacon: false });
    setConsoleTableColumns((prev) => prev.map((item) => ({ ...item, isSelected: true })));
    setIsTableWidth(1400);
    setAllFilters((prev) => ({
      ...prev,
      bandsFilter: [],
      tctmFilter: [],
      advanceFilters: [],
      timeFilter: { startTime: null, endTime: null },
    }));
    handleChangeFilter({
      bandsFilter: [],
      tctmFilter: [],
      advanceFilters: [],
      timeFilter: { startTime: null, endTime: null },
    });
  };

  useEffect(() => {
    const isAnyAudioFilterOff = Object.values(audioWaveformFilters).some((v) => v);
    const isAnyTcTmFilterOff = Object.values(tcTmTypeFilters).some((v) => v);
    const isAnyColumnUnselected = consoleTableColumns.some((col) => col.isSelected === false);
    setIsResetActive(isAnyAudioFilterOff || isAnyTcTmFilterOff || allFilters?.advanceFilters?.length > 0 || !!allFilters?.timeFilter?.startTime || !!allFilters?.timeFilter?.endTime);
    setIsSelectAllFiltersActive(isAnyColumnUnselected);
  }, [audioWaveformFilters, tcTmTypeFilters, consoleTableColumns, allFilters]);

  useEffect(() => {
    const close_open_modal = (event: any) => {
      if (event.target instanceof Element && (
        event.target.closest('.generic_simulator_console__container') ||
        event.target.closest('.gs__elp') ||
        event.target.closest('.right__button__container')
      )) return;
      const currentModal = get_modal_details('generic_simulator_console');
      if (!currentModal.open || currentModal.pinned) return;
      close_all_unpinned_modals();
      set_show_rawbytes(false);
    };

    window.addEventListener("click", close_open_modal);
    return () => window.removeEventListener("click", close_open_modal);
  }, [get_modal_details, close_all_unpinned_modals]);

  const handleChangeFilter = async (filters: any) => {
    const event = new CustomEvent("postFilters", { detail: filters });
    window.dispatchEvent(event);
    window.dispatchEvent(new CustomEvent("removeSelection"));
  };

  useEffect(() => {
    window.addEventListener('openGenericSimulatorConsole', reset_filters);
    return () => window.removeEventListener('openGenericSimulatorConsole', reset_filters);
  }, []);

  return (
    <Modal
      open={modal.open}
      pinned={modal.current_modal === "generic_simulator_console" && modal.pinned}
      disabled={(modal.current_modal === "generic_simulator_console" && modal.pinned) || resizing}
      class_name={modal.current_modal === "generic_simulator_console" ? "current__modal" : ""}
    >
      <div className="generic_simulator_console__container console__container" onClick={handleOpenConsole}>
        <div className="console__container__right__panel active">
          <div className="console__container__right__panel__container">
            <div className="right__panel__header">
              <span className="header__title">Messages</span>
              <div className="d-flex align-items-center gap-1">
                <div className="console__header__raw__bytes__div">
                  <button
                    className={`custom__toggle__btn__container ${show_rawbytes ? "active" : ""}`}
                    onClick={() => {
                      set_show_rawbytes(!show_rawbytes);
                      setIsFrozen(false);
                    }}
                  />
                  <span>Raw Bytes</span>
                </div>
                <button className={`right__panel__pin__btn ${modal.pinned ? "pinned" : ""}`} onClick={handlePinFunctionality}>
                  <PinSvg />
                </button>
                <button className="right__panel__close__btn d-flex" onClick={handleCloseConsole}>
                  <CloseIcon />
                </button>
              </div>
            </div>

            {!show_rawbytes && (
              <div className="right__panel__header__filters" style={{ padding: "12px 0px", justifyContent: "flex-end" }}>
                <CustomFilter
                  timeRange={timeRange}
                  alignment="left"
                  bandsFilter={{
                    bands: bandOptions,
                    onClick: (bandKey: string) => setAudioWaveformFilters((prev) => ({ ...prev, [bandKey]: !prev[bandKey as keyof typeof prev] })),
                    applyFilter: (filters: any) => handleChangeFilter(filters),
                  }}
                  tctmFilter={{
                    tctms: [
                      { label: 'Health Metric', value: 'healthMetric', Icon: <HealthMetricSvg /> },
                      { label: 'Beacon', value: 'beacon', Icon: <BeaconSvg /> },
                      { label: 'Invalid TM', value: 'invalid', Icon: <InvalidTmSvg /> },
                    ],
                    onClick: (tctm: any) => setTcTmTypeFilters((prev) => ({ ...prev, [tctm?.value]: !prev[tctm?.value as keyof typeof prev] })),
                    applyFilter: (filters: any) => handleChangeFilter(filters),
                  }}
                  timeFilter={{ applyFilter: (filters: any) => handleChangeFilter(filters) }}
                  advanceFilter={{
                    filterIcon: null,
                    filterList: filterOption,
                    applyFilter: (filters: any) => handleChangeFilter(filters),
                  }}
                  allFilters={allFilters}
                  setAllFilters={setAllFilters}
                  filterCase="console"
                  boundingScreen="console__container__right__panel"
                />
                <div className="right__panel__header__filters__input__div">
                  <button className={`right__panel__header__filters__reset__btn ${isResetActive ? "active" : "inactive"}`} onClick={reset_filters}>
                    Reset
                  </button>
                  <button className="right__panel__header__filters__icons" onClick={exportMessages}>
                    <CustomToolTip title="Download File" placement="top">
                      <DownloadIcon />
                    </CustomToolTip>
                  </button>
                  <button className="right__panel__header__filters__icons" onClick={() => setIsTableFiltersVisible(!isTableFiltersVisible)}>
                    <CustomToolTip title="Select Columns" placement="top">
                      <ThreeDotIcon />
                    </CustomToolTip>
                  </button>

                  {isTableFiltersVisible && (
                    <ThreeDotMenuPopUp
                      useDragHandle
                      onSortEnd={handleSortEnd}
                      helperClass="draggable-item-console-helper"
                      lockOffset="0%"
                      lockAxis="y"
                      axis="y"
                      lockToContainerEdges={true}
                      threeDotMenuPopUpRef={threeDotMenuPopUpRef}
                      isSelectAllFiltersActive={isSelectAllFiltersActive}
                      setIsTableWidth={setIsTableWidth}
                      consoleTableColumns={consoleTableColumns}
                      setConsoleTableColumns={setConsoleTableColumns}
                      isTableWidth={isTableWidth}
                    />
                  )}
                </div>
              </div>
            )}

            {show_rawbytes && (
              <div className="right__panel__header__filters" style={{ padding: "12px 0px", justifyContent: "flex-end" }}>
                <div className="right__panel__header__filters__input__div" />
              </div>
            )}

            <div className="right__panel__body">
              {!show_rawbytes && (
                <ConsoleOutputSection
                  loading={loading}
                  error={error}
                  commandDetails={commandDetails}
                  getCommandDetails={getCommandDetails}
                  set_resizing={setResizing}
                  consoleTableColumns={consoleTableColumns}
                  isTableWidth={isTableWidth}
                  allFilters={allFilters}
                  isFrozen={isFrozen}
                  setIsFrozen={setIsFrozen}
                />
              )}
              {show_rawbytes && (
                <RawBytesOutputSection loading={loading} error={error} commandDetails={commandDetails} getCommandDetails={getCommandDetails} set_resizing={setResizing} truetwinId={trueTwinId} />
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default GenericSimulatorConsole;
